var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('WalletBalance',{attrs:{"wallet":_vm.currentWallet}}),(_vm.isInfluencer)?_c('WalletBalance',{attrs:{"wallet":_vm.otherWallet}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }